import './_styles.signin.css';
import AuthUI from './AuthUI';

const SignIn = () => {
  return <AuthUI type='signin' />;
};

export default SignIn;
